import React from 'react';

/**
 * MVM Logo Component - Teal Gradient Rounded Style
 * Used across the app for branding
 * 
 * @param {string} size - 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' (default: 'md')
 * @param {string} variant - 'default' | 'light' (default: 'default')
 * @param {string} className - Additional CSS classes
 */
const MVMLogo = ({ size = 'md', variant = 'default', className = '' }) => {
  const sizes = {
    xs: { width: '32px', text: 'text-[8px]', radius: 'rounded-lg' },
    sm: { width: '40px', text: 'text-[10px]', radius: 'rounded-xl' },
    md: { width: '48px', text: 'text-xs', radius: 'rounded-xl' },
    lg: { width: '64px', text: 'text-base', radius: 'rounded-2xl' },
    xl: { width: '80px', text: 'text-lg', radius: 'rounded-2xl' },
    '2xl': { width: '96px', text: 'text-xl', radius: 'rounded-3xl' }
  };

  const sizeConfig = sizes[size] || sizes.md;
  const isLight = variant === 'light';

  return (
    <div
      style={{ 
        width: sizeConfig.width, 
        height: sizeConfig.width, 
        minWidth: sizeConfig.width,
        minHeight: sizeConfig.width,
        maxWidth: sizeConfig.width,
        maxHeight: sizeConfig.width,
        boxSizing: 'border-box'
      }}
      className={`
        ${sizeConfig.radius}
        ${isLight 
          ? 'bg-white/20 border-white/30 border' 
          : 'bg-gradient-to-br from-teal-500 to-cyan-600'
        }
        flex items-center justify-center flex-shrink-0
        ${isLight ? 'shadow-lg shadow-white/20' : 'shadow-lg shadow-teal-500/30'}
        ${className}
      `}
    >
      <span
        className={`
          ${sizeConfig.text}
          font-bold
          text-white
          tracking-tight
        `}
      >
        MVM
      </span>
    </div>
  );
};

export default MVMLogo;
